module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ModalContainer', {
    staticClass: "basic-modal"
  }, [_c('Card', {
    staticClass: "modal-content mx-auto"
  }, [_c('div', {
    staticClass: "mdl-card__title typography--color-primary typography--font-weight-500 basic-modal-header",
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  }), _vm._v(" "), (!_vm.hideBody) ? _c('div', {
    staticClass: "mdl-card__supporting-text mdl-typography--body-1 basic-modal-body"
  }, [_vm._t("default", [_vm._v("body")])], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__actions text-right basic-modal-actions"
  }, [(!_vm.hideCancel) ? _c('button', {
    directives: [{
      name: "mdl",
      rawName: "v-mdl"
    }],
    staticClass: "mdl-button mdl-button--primary mdl-js-button mdl-js-ripple-effect",
    on: {
      "click": function($event) {
        return _vm.$emit('cancel')
      }
    }
  }, [_vm._v("\n        취소\n      ")]) : _vm._e(), _vm._v(" "), _c('button', {
    directives: [{
      name: "mdl",
      rawName: "v-mdl"
    }],
    staticClass: "mdl-button mdl-button--primary mdl-js-button mdl-js-ripple-effect",
    attrs: {
      "disabled": _vm.okDisabled
    },
    on: {
      "click": function($event) {
        return _vm.$emit('ok')
      }
    }
  }, [_vm._v("\n        확인\n      ")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7623e3fe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BasicModal.vue
// module id = 1593
// module chunks = 1